import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-crm-workflow',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './crm-workflow.html',
  styleUrls: ['./crm-workflow.css'],
})
export class CrmWorkflowComponent {
  readonly schedule = [
    { time: '9:00 AM', label: 'Call — Ahmed Khan' },
    { time: '11:30 AM', label: 'Meeting — Site visit' },
    { time: '2:00 PM', label: 'Follow-up — Quote sent' },
  ];

  readonly campaignStats = [
    { value: '1,240', label: 'Contacts reached' },
    { value: '18%', label: 'Open rate' },
    { value: '42', label: 'New leads generated' },
  ];

  readonly tickets = [
    { id: '#1042', label: 'Delivery delay', status: 'Open', statusClass: 'status-open' },
    { id: '#1041', label: 'Refund request', status: 'In progress', statusClass: 'status-progress' },
    { id: '#1039', label: 'Product question', status: 'Resolved', statusClass: 'status-resolved' },
  ];
}
